<template>
    <files :reference-id="projectId" reference-type="project" />
</template>

<script>
    import { mapActions } from 'vuex'
    import Files from './../../../components/Files'

    export default {
        components: {
            Files,
        },

        computed: {
            projectId () {
                return parseInt(this.$route.params.slug)
            }
        },

        mounted() {
            this.fetchFiles({project_id: this.projectId})
        },

        methods: {
            ...mapActions(['fetchFiles'])
        }
    }
</script>
